// extracted by mini-css-extract-plugin
export default {"Spinner":"Loading_Spinner__GRzw7"};